import { render, staticRenderFns } from "./NotificationsPage.vue?vue&type=template&id=54f8c3b4&scoped=true"
import script from "./NotificationsPage.vue?vue&type=script&lang=js"
export * from "./NotificationsPage.vue?vue&type=script&lang=js"
import style0 from "./NotificationsPage.vue?vue&type=style&index=0&id=54f8c3b4&prod&lang=scss&scoped=true"
import style1 from "./NotificationsPage.vue?vue&type=style&index=1&id=54f8c3b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f8c3b4",
  null
  
)

export default component.exports